<script setup>
// 2. Different placeholders
// 4. Animation/transition

const props = defineProps({
  src: { type: String, required: true },
  alt: { type: String, default: "" },
  fit: { type: String, default: "cover" }, // contain inside parent by default
  placeholder: { type: String, default: null },
});

const { magicImageUrl } = useMagicImage();

// Placeholder: same image, but tiny and aggressively blurred
const placeholderSrc =
  props.placeholder ||
  magicImageUrl(props.src, {
    width: 200,
    dpr: 1,
    blur: 50,
    fit: props.fit,
  });
</script>

<template>
  <img
    :class="fit === 'cover' ? 'object-cover' : 'object-contain'"
    :src="placeholderSrc"
    :data-magic-img-src="props.src"
    :data-magic-img-fit="props.fit"
    :alt="alt"
    loading="lazy"
    decoding="async"
  />
</template>
